import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import useAuthStore from '../lib/auth-store';
import { apiFetch, fmtDate } from './merchant/attributionApi';

export function NotificationBell() {
  const { token } = useAuthStore();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const load = useCallback(() => apiFetch(token, '/elearning/notifications').then(setItems).catch(() => {}), [token]);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const unread = items.filter((n) => !n.read).length;
  const open = async (n) => {
    if (!n.read) await apiFetch(token, `/elearning/notifications/${n.id}/read`, 'POST').catch(() => {});
    if (n.link) navigate(n.link);
    load();
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notifications-btn">
          <Bell className="h-5 w-5" />
          {unread > 0 && <span className="absolute top-1 right-1 min-w-4 h-4 px-1 text-[10px] leading-4 text-white bg-red-500 rounded-full" data-testid="notifications-unread-count">{unread}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notifications-panel">
        <p className="px-4 py-3 text-sm font-semibold border-b">Notifications</p>
        <div className="max-h-80 overflow-auto">
          {!items.length && <p className="px-4 py-6 text-sm text-muted-foreground text-center">You're all caught up</p>}
          {items.map((n) => (
            <button key={n.id} onClick={() => open(n)} data-testid={`notification-${n.id}`}
                    className={`w-full text-left px-4 py-3 border-b last:border-0 text-sm hover:bg-muted transition-colors ${n.read ? 'opacity-60' : ''}`}>
              <p>{n.message}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{fmtDate(n.created_at)}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
